"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class CustomerService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    fetchCustomer(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/customer?page=${payload.pageNumber}&limit=${payload.limit}&customersWithLedger=${payload.withLedger}&getAllBalance=${payload.getAllBalance}`;
                let response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const respData = response.data.data;
                return respData;
            }
            catch (error) {
                throw new Error('Error while fetching customer');
            }
        });
    }
    createCustomer(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/customer`;
                payload = JSONbig.stringify(payload);
                let response = yield axios_1.default.post(url, payload, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                return response.data.data.id;
            }
            catch (error) {
                throw new Error('Error while creating customer');
            }
        });
    }
    updateCustomer(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/customer`;
                payload = JSONbig.stringify(payload);
                let response = yield axios_1.default.put(url, payload, {
                    headers: header
                });
                return response.data.message;
            }
            catch (error) {
                throw new Error('Error while updating customer');
            }
        });
    }
    fetchDefaultCustomer() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/customer/default`;
                let response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header,
                    validateStatus: function (status) {
                        if (status == 404) {
                            return true;
                        }
                        return status >= 200 && status < 300;
                    }
                });
                return (_a = response.data.data) !== null && _a !== void 0 ? _a : [];
            }
            catch (error) {
                throw new Error('Error while fetching default customer');
            }
        });
    }
    createDefaultCustomer(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/customer/default`;
                payload = JSONbig.stringify(payload);
                let response = yield axios_1.default.post(url, payload, {
                    headers: header
                });
                return response.data.message;
            }
            catch (error) {
                throw new Error('Error while creating default customer');
            }
        });
    }
    searchCustomer(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/customer/search?page=${payload.pageNumber}&limit=${payload.limit}&query=${payload.searchQuery}&customersWithLedger=${payload.withLedger}&getAllBalance=${payload.getAllBalance}`;
                let response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const respData = response.data.data;
                return respData;
            }
            catch (error) {
                throw new Error('Error while searching customer');
            }
        });
    }
    checkCustomerExists(mobile) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}business/customer/check?mobile=${mobile}`;
                let response = yield axios_1.default.get(url, {
                    headers: header,
                    validateStatus: function (status) {
                        if (status == 404) {
                            return true;
                        }
                        return status >= 200 && status < 300;
                    }
                });
                return response;
            }
            catch (error) {
                throw new Error('Error while checking customer exists');
            }
        });
    }
}
exports.CustomerService = CustomerService;
